import { NAMESPACE_INTERESTING_MATCHES } from 'app/constants/Context';
import { selectAllConflictedIds } from 'app/modules/BetSlip/selectors/conflict';
import { selectBets as bets } from 'app/modules/BetSlip/selectors/entries';
import { addBet } from 'app/modules/LandingPage/InterestingMatches/actions';
import * as entitySelectors from 'app/modules/LandingPage/InterestingMatches/selectors/entities';
import * as gridSelectors from 'app/modules/LandingPage/InterestingMatches/selectors/grid';
import { setGridOrderKey, setInterestingMatchesGridStakeTypes } from 'app/redux/betting-presentation/grid/actions';

// --

/**
 * `<InterestingMatches/>` module's betting context.
 */
export default {
  namespace: NAMESPACE_INTERESTING_MATCHES,

  content: {
    selectors: entitySelectors,
  },

  grid: {
    selectors: gridSelectors,
    actions: {
      setGridOrderKey,
      changeStakeTypeGroup: setInterestingMatchesGridStakeTypes,
    },
  },

  staking: {
    selectors: { bets, selectAllConflictedIds },
    actions: { addBet },
  },
};
